module.exports = __webpack_public_path__ + "img/266-1.2ed33d2d.png";